/**
 * ImpersonationBanner.jsx · v101.27.0 · Barra fija mientras el super_admin está «Entrando como» otro usuario.
 * Muestra a quién ve, quién inició, el tiempo restante y «Volver a mi cuenta». Al vencer, vuelve sola.
 */
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye, LogOut } from "lucide-react";
import { getImpersonation, endImpersonation } from "../lib/impersonation";

const fmt = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};

export default function ImpersonationBanner() {
  const [info, setInfo] = useState(getImpersonation);
  const [left, setLeft] = useState(0);

  // Mensaje al volver a la cuenta propia (después del redirect)
  useEffect(() => {
    try {
      const m = sessionStorage.getItem("afc_imp_msg");
      if (m) { sessionStorage.removeItem("afc_imp_msg"); toast.info(m); }
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    if (!info) return undefined;
    const tick = () => {
      const ms = new Date(info.expires_at).getTime() - Date.now();
      setLeft(ms);
      if (ms <= 0) endImpersonation("La sesión «Entrar como» terminó (60 min). Volviste a tu cuenta.");
    };
    tick();
    const t = setInterval(tick, 1000);
    const onStorage = () => setInfo(getImpersonation());
    window.addEventListener("storage", onStorage);
    return () => { clearInterval(t); window.removeEventListener("storage", onStorage); };
  }, [info]);

  if (!info) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70] max-w-[calc(100vw-2rem)]" data-testid="impersonation-banner">
      <div className="flex items-center gap-3 rounded-full bg-red-700 text-white shadow-2xl px-4 py-2 text-sm ring-4 ring-red-300/60">
        <Eye size={16} className="flex-shrink-0" />
        <div className="truncate">
          Viendo como <b>{info.target?.name}</b>
          <span className="opacity-80"> · {info.target?.role_display}</span>
          <span className="opacity-80 hidden sm:inline"> · por {info.admin?.name || info.admin?.email}</span>
          <span className="font-mono ml-2">{fmt(left)}</span>
        </div>
        <button
          onClick={() => endImpersonation()}
          className="flex items-center gap-1 rounded-full bg-white text-red-700 font-semibold px-3 py-1 text-xs hover:bg-red-50 flex-shrink-0"
          data-testid="impersonation-exit"
        >
          <LogOut size={13} /> Volver a mi cuenta
        </button>
      </div>
    </div>
  );
}
